export default __webpack_public_path__ + "static/media/edit.d25758f9.svg";